import { CandidateProfile } from "../../Candidate/Types/CandidateType";
import { SubscriptionPlanResponse } from "../../PaymentAndSubcription/Types/SubscriptionPlanType";
import { PaginationResponse } from "../../Shared/Pagination/PaginationResponse";
import { getApi, getApiById, getApiListById, getApiListWithoutId, postApi, putApi } from "../../Shared/Services/RestService";
import { SuggestionResponse } from "../Types/candidateSuggestionService";
import { SavedFilterResponse, SearchFilterResponse } from "../Types/SerachFileter";

export const getAllSearchFilters = () => {
  return getApi<SearchFilterResponse[]>("/admin/search-filters");
};

export const getSubscriptionPlanById = (id: string ) => {
  return getApiById<SubscriptionPlanResponse | null>("/subscriptions", id);
};


export const createSubscriptionPlan = (payload: any) => {
  return postApi<SubscriptionPlanResponse>("/subscriptions", payload);
};

export const updateSubscriptionPlan = (payload: any, id: string) => {
  return putApi<SubscriptionPlanResponse | null>("/subscriptions", id, payload);
};


export const getAllSearchFiltersBySubscriptionPlan = (id: string ) => {
  return getApiById<SearchFilterResponse []>("/admin/search-filters/plan", id);
};



export const candidateSearch = (payload: any) => {
  return postApi<CandidateProfile[]>("/candidates/search", payload);
};



export const getSuggestions = (payload: any) => {
  return postApi<SuggestionResponse>("/candidates/suggestions", payload);
};


export const getGlobalSuggestions = (payload: any) => {
  return postApi<SuggestionResponse>("/search/suggestions", payload);
};

export const saveFilter = (payload: any) => {
  return postApi<SuggestionResponse>("/saved-filters", payload);
};

export const updateFilter = (payload: any, id: string) => {
  return putApi<SuggestionResponse>("/saved-filters",  id, payload);
};


export const getAllSavedFiltersUser = (page: number = 0 ,size?: number  ) => {
  const params: any = {
    page,
  };    

  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListWithoutId<PaginationResponse<SavedFilterResponse>>("/saved-filters/user/me", params);
};


export const getAllSavedFiltersCompany = (page: number =0 ,size?: number  ) => {
  const params: any = {
    page,
  };    

  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListWithoutId<PaginationResponse<SavedFilterResponse>>("/saved-filters/user/company", params);
};